import type { ClientSessionState, SessionStreamEvent } from 'eve/client'

import { toRaw } from 'vue'

/** Older cached facts must be read again through eve's v27 stream converter. */
export function restoreDocueAgentSession(saved?: {
  eventVersion?: number
  events: readonly SessionStreamEvent[]
  session?: ClientSessionState
} | null) {
  const current = saved?.eventVersion === 27
  return {
    // eve clones event data, which cannot include useSessionStorage's Vue proxies.
    initialEvents: current ? toRaw(saved.events) : [],
    initialSession: saved?.session?.sessionId
      ? { ...saved.session, streamIndex: current ? saved.session.streamIndex : 0 }
      : undefined,
  }
}
